import * as React from "react";
import { FileSystemTypes } from "../utils";
import { CpRadioCardGroup } from "../../gvc/testNewForm/CpRadioCardGroup";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { FormItem } from "../../../components/antd/form/FormItem";
import { FormItemValue } from "../../../components/antd/form/FormItemValue";

export type FileSystemType = "ext4" | "xfs" | "shared";

interface Props {
  /** If provided, locks the file system type to this value and renders read-only */
  lockedValue?: FileSystemType;
}

export const VolumeSetSpecFileSystemType: React.FC<Props> = ({ lockedValue }) => {
  if (lockedValue) {
    const fsInfo = FileSystemTypes.find((fs) => fs.name === lockedValue);
    return (
      <FormItem>
        <CpLabel name="fileSystemType">File System Type</CpLabel>
        <FormItemValue>{lockedValue}</FormItemValue>
        {fsInfo && (
          <div className="text-sm text-gray-500 mt-1">
            Access Mode: {fsInfo.accessMode}
          </div>
        )}
      </FormItem>
    );
  }

  return (
    <CpFormItem>
      <CpLabel name="fileSystemType">File System Type</CpLabel>
      <CpRadioCardGroup
        name="fileSystemType"
        options={FileSystemTypes.map((fs) => ({
          label: fs.name,
          value: fs.name,
          boldLabel: true,
          children: (
            <div style={{ minWidth: 200 }}>
              <div className="text-sm my-2">Access Mode: {fs.accessMode}</div>
              <div className="text-sm mb-1">Supported Commands;</div>
              <ul>
                {fs.commandsSupported.map((cmd) => (
                  <li key={cmd} className="text-sm ml-2">
                    {cmd}
                  </li>
                ))}
              </ul>
            </div>
          ),
        }))}
      />
      <CpErrorWarning name="fileSystemType" />
    </CpFormItem>
  );
};
